import classNames from 'classnames'
import { NextPageContext } from 'next'
import { useEffect, useRef } from 'react'
import Button from '../../../components/_legacy/Button'
import Col from '../../../components/basic/Col'
import BasicHead from '../../../components/common/BasicHead'
import CenterContainer from '../../../components/common/CenterContainer'
import CsrOnlyStudentBrazePixel from '../../../components/common/CsrOnlyStudentBrazePixel'
import DeviceSplit from '../../../components/common/DeviceSplit'
import VWContainer from '../../../components/common/VWContainer'
import TailwindWrapper from '../../../components/container/TailwindWrapper'
import CircleTextBox from '../../../components/landing-legacy/CircleTextBox'
import InputWithLabel from '../../../components/landing-legacy/InputWithLabel'
import MainTitle from '../../../components/landing-legacy/MainTitle'
import BusinessBodyDesktop from '../../../components/landing/body/desktop/BusinessBody'
import BusinessBodyMobile from '../../../components/landing/body/mobile/BusinessBody'
import {
  IMG_HOME_DESKTOP_COMPANY_ROW_ONE,
  IMG_HOME_DESKTOP_COMPANY_ROW_THREE,
  IMG_HOME_DESKTOP_COMPANY_ROW_TWO,
} from '../../../components/landing/constants/home.constants'
import LandingNav from '../../../components/landing/navigation/LandingNav'
import MobileLandingNav from '../../../components/landing/navigation/LandingNav/MobileLandingNav'
import Footer from '../../../components/landing/section/footer'
import { GTM_EVENT, sendGTMEvent } from '../../../helpers/gtmHelper'
import { InitialProps } from '../../../model/Common/common.interface'
import apis from '../../../modules/apis'
import { axiosPost } from '../../../modules/axiosHelper'
import { logVisitEvent } from '../../../modules/braze/logVisitRecord'
import { useCurrentUser } from '../../../modules/context/UserContext'
import useAppRouter from '../../../modules/hooks/common/useAppRouter'
import useGetViewportSize from '../../../modules/hooks/common/useGetViewportSize'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'
import { LOCALE_EN, LOCALE_KO } from '../../../modules/i18n/config'
import { s_b2b, s_head } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import { HERO_B2B, IC_B2B1, IC_B2B2, IC_B2B3, IMG_B2B_IMG_B2B1, IMG_B2B_IMG_B2B1_EN } from '../../../modules/images'
import { getOgUrl, t } from '../../../modules/utils'

const Index = ({ ogData, isMobileServer }: InitialProps) => {
  const isMobile = useIsMobile(isMobileServer)

  const { currentUser } = useCurrentUser()
  const { t, locale } = useTranslation()
  const nameRef = useRef(null)
  const emailRef = useRef(null)
  const phoneRef = useRef(null)
  const askRef = useRef(null)
  const router = useAppRouter()

  const list = [
    {
      title: t(s_b2b.oneclick_system),
      text: t(s_b2b.oneclick_easy),
    },
    {
      title: t(s_b2b.case_materials),
      text: t(s_b2b.written_by_MBA),
    },
    {
      title: t(s_b2b.top_20_tutors),
      text: t(s_b2b.choose_tutors),
    },
  ]

  const list2 = [
    {
      title: t(s_b2b.propose_b2b),
      text: t(s_b2b.no_limit_proposal),
      imgUrl: IC_B2B1,
    },
    {
      title: t(s_b2b.run_b2b),
      text: t(s_b2b.download_excel),
      imgUrl: IC_B2B2,
    },
    {
      title: t(s_b2b.manage_b2b),
      text: t(s_b2b.b2b_one_on_one),
      imgUrl: IC_B2B3,
    },
  ]

  const desktopUrl = t([IMG_B2B_IMG_B2B1, IMG_B2B_IMG_B2B1_EN])
  const circleTexts = [
    { circle: '3,500+', desc: t(s_b2b.total_number_tutees) },
    { circle: '200+', desc: t(s_b2b.partners) },
    { circle: '94%', desc: t(s_b2b.satisfaction) },
  ]
  const viewport = useGetViewportSize()

  const handleSubmit = async (e) => {
    e.preventDefault()
    const name = nameRef.current?.value
    const email = emailRef.current?.value
    const phone = phoneRef.current?.value
    const content = askRef.current?.value

    if (!name || !email || !content) {
      alert(t(s_b2b.please_fill_in_blank))
      return
    }

    const response = await axiosPost(apis.landing.partner(), {
      name: name,
      email: email,
      content: content,
      phone: phone,
    })

    if (response.success) {
      sendGTMEvent(GTM_EVENT.SUBMIT_APPLICATOIN)
      window.location.reload()
    }
  }

  useEffect(() => {
    if (!router) return

    sendGTMEvent(GTM_EVENT.VIEW_CONTENT, {
      page_location: 'Landing_B2B',
    })
  }, [router.asPath])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    const handleClickTab = (sectionId) => {
      const element = document?.getElementById(sectionId)

      if (element) {
        const topPos = element.offsetTop

        window.scrollTo({
          top: topPos,
          behavior: 'smooth',
        })
      }
    }

    if (router.query.sectionId) {
      setTimeout(() => {
        handleClickTab(router.query.sectionId)
      }, 1000)
    }
  }, [router.query])

  return (
    <div>
      <BasicHead ogData={ogData} />
      <CsrOnlyStudentBrazePixel
        currentUser={currentUser}
        callback={(appBoy) =>
          logVisitEvent(appBoy, 'view_landing', {
            property_1: 'b2b',
            locale: locale,
          })
        }
      />
      <DeviceSplit isMobile={isMobile} mobile={<MobileLandingNav />} desktop={<LandingNav />} />

      {/* 국문 / 영문 일 때 신규 디자인으로 렌더링 */}
      {(locale === LOCALE_KO || locale === LOCALE_EN) && (
        <DeviceSplit isMobile={isMobile} mobile={<BusinessBodyMobile />} desktop={<BusinessBodyDesktop />} />
      )}

      {/* 그 외 언어 일 때는 구 버전으로 렌더링 */}
      {locale !== LOCALE_KO && locale !== LOCALE_EN && (
        <TailwindWrapper>
          <MainTitle
            bgImg={HERO_B2B(viewport)}
            title={
              <>
                <div className="mb-[8px] text-white">{t(s_b2b.experience_ringle)}</div>
                <h1 className="text-d5 sm:text-d1 font-bold text-white">{t(s_b2b.better_english_for_company)}</h1>
              </>
            }
            button={
              <a href="#b2b-inquiry" className="mt-[24px] block py-[18px] text-center md:text-left">
                <Button outlined lg>
                  <div className="text-center">{t(s_b2b.ask_b2b)}</div>
                </Button>
              </a>
            }
          />
          <VWContainer>
            <CenterContainer className="pt-96 text-center">
              <div className="flex flex-col items-center md:flex-row md:items-center">
                {list.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className={classNames(
                        classNames({
                          'mb-64': i + 1 < list.length,
                          'sm:mb-0': true,
                        }),
                        'flex-1'
                      )}
                    >
                      <div className="text-h4 font-bold text-gray-700">{item.title}</div>
                      <div className="text-h5 mt-[8px] text-gray-700">{item.text}</div>
                    </div>
                  )
                })}
              </div>
            </CenterContainer>
          </VWContainer>
          <VWContainer>
            <CenterContainer className="pt-96 text-center">
              <div className="text-h3 text-purple-500">{t(s_b2b.manage_study)}</div>
              <div className="text-d6 sm:text-d4 mt-[24px] font-bold">{t(s_b2b.b2b_team_manage_study)}</div>
              <div className="mt-[16px] text-gray-500">{t(s_b2b.fit_b2b_service)}</div>
              <div className="relative mt-[64px] w-full">
                <img src={desktopUrl} className="absolute h-full w-full object-cover" alt="b2b-desktop-url" />
                <img src="/assets/img/devices/macbook.svg" className="h-auto max-w-full" alt="b2b-macbook" />
              </div>
              <div className="mt-[32px] mb-[95px] flex flex-col items-center justify-evenly md:flex-row md:items-start">
                {circleTexts.map((item, i) => {
                  return <CircleTextBox key={i} circle={<>{item.circle}</>} desc={item.desc} />
                })}
              </div>
            </CenterContainer>
          </VWContainer>
          <VWContainer clx="border-t border-b border-solid border-gray-200">
            <CenterContainer className="py-96 text-center">
              <div className="text-h3 text-purple-500">{t(s_b2b.ringle_b2b_program)}</div>
              <div className="text-d6 sm:text-d4 mt-[24px] font-bold">{t(s_b2b.serve_high_quality_education)}</div>
              <div className="mt-[64px] flex flex-col items-center md:flex-row md:items-start">
                {list2.map((item, i) => {
                  return (
                    <div
                      key={i}
                      className={classNames(
                        classNames({
                          'mb-64': i + 1 < list.length,
                        }),
                        'flex-1 items-center justify-center'
                      )}
                    >
                      <div className="flex items-center justify-center text-center">
                        <img src={item.imgUrl} alt="image" />
                      </div>
                      <div className="mt-[24px] font-bold text-gray-700">{item.title}</div>
                      <div className="text-h5 mt-[8px] text-gray-700">{item.text}</div>
                    </div>
                  )
                })}
              </div>
            </CenterContainer>
          </VWContainer>
          <VWContainer>
            <CenterContainer className="py-96 text-center">
              <div className="text-d6 sm:text-d4 font-bold">{t(s_b2b.ringle_b2b_companies)}</div>
              <div className="mt-[52px] space-y-20">
                <img src={IMG_HOME_DESKTOP_COMPANY_ROW_ONE} alt="company-row-one" />
                <img src={IMG_HOME_DESKTOP_COMPANY_ROW_TWO} alt="company-row-one" />
                <img src={IMG_HOME_DESKTOP_COMPANY_ROW_THREE} alt="company-row-one" />
              </div>
            </CenterContainer>
          </VWContainer>
          <a id="b2b-inquiry"></a>
          <VWContainer bgColor="bg-gray-50">
            <CenterContainer className="py-96 text-center">
              <div className="text-d6 sm:text-d4 font-bold">{t(s_b2b.start_with_ringle)}</div>
              <div className="mt-[16px] text-gray-700">{t(s_b2b.one_for_free)}</div>
              <div className="mt-[64px]">
                <div className="row flex items-center justify-center">
                  <Col>
                    <InputWithLabel ref={nameRef} label={t(s_b2b.name)} placeholder={t(s_b2b.enter_name)} />
                  </Col>
                  <Col clx="smd:mt-16 sm:mt-0">
                    <InputWithLabel ref={phoneRef} label={t(s_b2b.phone)} placeholder={t(s_b2b.enter_phone)} />
                  </Col>
                </div>
                <div className="row mt-[16px] flex items-center justify-center">
                  <Col>
                    <InputWithLabel ref={emailRef} label={t(s_b2b.email)} placeholder={t(s_b2b.enter_email)} />
                  </Col>
                </div>
                <div className="row mt-[16px] flex items-center">
                  <Col>
                    <InputWithLabel
                      ref={askRef}
                      label={t(s_b2b.ask_partner)}
                      textarea
                      placeholder={t(s_b2b.enter_question)}
                    />
                  </Col>
                </div>
                <Button clx="mt-64" outlined lg onClick={handleSubmit}>
                  {t(s_b2b.submit)}
                </Button>
              </div>
            </CenterContainer>
          </VWContainer>
        </TailwindWrapper>
      )}

      <Footer />
    </div>
  )
}

Index.getInitialProps = async (context: NextPageContext) => {
  const { lang = LOCALE_KO } = context.query
  const ogData = {
    title: t(s_head.student.title, lang),
    desc: t(s_head.student.desc, lang),
    ogUrl: getOgUrl({ lang, context }),
  }

  let userAgent: string | undefined

  if (context.req) {
    // if you are on the server and you get a 'req' property from your context
    userAgent = context.req.headers['user-agent'] // get the user-agent from the headers
  } else {
    userAgent = navigator.userAgent // if you are on the client you can access the navigator from the window object
  }

  const isMobileServer = userAgent
    ? Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))
    : false

  return {
    ogData,
    isMobileServer,
  }
}

export default Index
